import {observer} from 'mobx-react';
import React from 'react';

import {useI18n} from '@udemy/i18n';

import {Notification} from './notification.react-component';
import {NotificationsStore} from './notifications.mobx-store';
import styles from './styles.module.less';

interface NotificationsProps {
    store?: NotificationsStore;
}

export const Notifications: React.FC<NotificationsProps> = observer(({store: storeProp}) => {
    const {gettext} = useI18n();
    const [store] = React.useState(storeProp ?? new NotificationsStore(gettext));

    return (
        <div className={styles.notifications}>
            {store.notifications.map((notification, index) => (
                <Notification
                    key={index}
                    notification={notification}
                    onRemove={() => store.remove(notification)}
                />
            ))}
        </div>
    );
});
